import config from 'cfg';

export const SOCIAL_NETWORKS = [
    {
        title: 'TW',
        getAddress: client => `${config.apis.smpg}/twitter/connect?client=${client}&service=any`,
        key: 'tw',
        label: 'Add twitter account',
    },
    {
        title: 'FB',
        getAddress: client => `${config.apis.smpg}/facebook/connect?client=${client}&service=any`,
        key: 'fb',
        label: 'Add fb page',
    },
    {
        title: 'TG',
        getAddress: client => `${config.apis.smpg}/telegram/connect?client=${client}&service=any`,
        key: 'telegram',
        label: 'Add telegram channel',
    },
    {
        title: 'LB',
        getAddress: client => `${config.apis.smpg}/liveblog/connect?client=${client}&service=any`,
        key: 'liveblog',
        label: 'Add live blog',
    },
];

export const SMLINKS_BY_USER_ID = `${config.apis.smpg}/smlinks`;

export const STORE_KEYS = {
    SMLINKS: 'smlinks',
    WIDGET_SPECS: 'widget-specs',
    TEMPLATES: 'templates',
    TEMPLATE_BY_ID: 'templatesById',
    PORTFOLIO: 'portfolio',
    CAMPAIGNS: 'campaigns',
    TOURNAMENTS: 'tournaments',
    EVENTS: 'events',
    TEAMS: 'teams',
    POSTS: 'posts',
    BY_ID: 'ById',
};

/**
 * Redux form constants
 */
export const CAMPAIGN_FORM_ID = 'campaign';
export const WIZZARD_FORM_ID = 'campaign-wizzard';
export const MANUAL_TRIGGER_FORM_ID = 'manual-trigger';
export const MANUAL_POST_FORM_ID = 'manual-post';

export const CAMPAIGN_FORM_KEYS = {
    TITLE: 'title',
    ACTIVE: 'active',
    TIMEZONE: 'timezone',
    LANGUAGE: 'language',
    NOTIFICATIONS: {
        ARRAY: 'notificationsTo',
        TYPE: 'type',
        VALUE: 'value',
    },
    TEMPLATE: 'template',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
    CALENDAR: 'calendar',
    MODERATION: 'moderation',
    USER_ID: 'userId',
    TARGETS: {
        ARRAY: 'targets',
        TYPE: 'type',
        VALUE: 'value',
    },
    RULES: {
        ARRAY: 'rules',
        KEY: 'triggerType',
        CONDITIONS: {
            ARRAY: 'conditions',
        },
    },
    WIDGET: {
        SECTION: 'presentation',
        TYPE: 'type',
        NAME: 'name',
        PARAMS: {
            SECTION: 'params',
            USER: 'user',
            CLIENT: 'client',
            THEME: 'theme',
            TEMPLATE: 'template',
            ADDITIONAL: {
                ARRAY: 'additional',
                KEY: 'key',
                VALUE: 'value',
                BY_TRIGGER: 'byTrigger',
                CUSTOM_VALUE: 'customValue',
            },
        },
        TRIGGER_PARAMS: {
            SECTION: 'triggerMappings',
        },
    },
};

export const PRESENTATION_TYPES = {
    WIDGET: 'widget-social',
};

export const LANGUAGES = [
    {
        name: 'Dansk',
        key: 'da',
    },
    {
        name: 'English',
        key: 'en',
    },
    {
        name: 'Norwegian',
        key: 'no',
    },
    {
        name: 'German',
        key: 'de',
    },
    {
        name: 'Finnish',
        key: 'fi',
    },
];

export const NOTIFICATION_TYPES = [
    {
        key: 'email',
        name: 'Email',
    },
];

export const POST_STATUS = {
    AWAITING: 'awaiting_for_moderation',
    PUBLISHED: 'finished',
    NOT_PUBLISHED: 'not-published',
    IN_PROGRESS: 'inprogress',
    REJECTED: 'rejected',
    FAILED: 'failed',
};

export const TIMEZONE_BUTTONS = ['Europe/Copenhagen', 'Europe/Oslo', 'Europe/Stockholm'];

export const LOADING_CLASSNAME = 'show-loading-animation';
export const LOADING_COLOR = '#ccc';
export const FINISHED_REQ_DELAY = 700;

export const GENERATE = 'GENERATE_';

export const GET = 'GET_';
export const SET = 'SET_';

export const POST = 'POST_';
export const PUT = 'PUT_';
export const DELETE = 'DELETE_';

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const FAIL = '_FAIL';



/** WEBPACK FOOTER **
 ** ../src/dash/front/constants.js
 **/